import React from 'react';
import './style.scss';

export default ({ label, subLabel }) => {
    return (
        <div className="fm-select-row fm-select-row__two">
            <p className="fm-select-row__label">{label}</p>
            <p className="fm-select-row__sub-label">{subLabel}</p>
        </div>
    );
};
